import { gql } from 'graphql-tag';
import type { TypedDocumentNode } from '@apollo/client';
import type { IGetTestCenterData } from '../types';

// Get everything for doing a full test center report.
export const GET_TEST_CENTER: TypedDocumentNode<IGetTestCenterData> = gql`
  query getTestCenter {
    viewer {
      id
      site {
        id
        staff {
          firstName
          id
          lastName
          role
          room {
            id
            groupTypes
            students {
              id
              checkedInRoom
              dapExamStatus {
                name
                timestamp
              }
              dapTestStatus {
                name
                payload {
                  ... on DAPSectionStartTime {
                    sectionName
                  }
                }
                timestamp
              }
            }
            title
          }
        }
        students {
          absent
          checkedInCenter
          checkedInRoom
          dapExamStatus {
            name
            timestamp
          }
          dapTestStatus {
            name
            payload {
              ... on DAPSectionStartTime {
                sectionName
              }
            }
            timestamp
          }
          deniedEntry
          groupType
          id
          room {
            id
            groupTypes
            title
          }
          waitListFlag
        }
      }
    }
  }
`;
